import apiClient, { extractData } from "./client";

export async function getWeeklyRestRequests(params = {}) {
  const response = await apiClient.get("/weekly-rest", { params });
  return extractData(response);
}

export async function getWeeklyRest(id) {
  const response = await apiClient.get(`/weekly-rest/${id}`);
  return extractData(response);
}

export async function getWeeklyRestHistory(id) {
  const response = await apiClient.get(`/weekly-rest/${id}/history`);
  return extractData(response);
}

export async function createWeeklyRestRequest(data) {
  const response = await apiClient.post("/weekly-rest", data);
  return extractData(response);
}

export async function approveWeeklyRest(id, data = {}) {
  const response = await apiClient.post(`/weekly-rest/${id}/approve`, data);
  return extractData(response);
}

export async function rejectWeeklyRest(id, data = {}) {
  const response = await apiClient.post(`/weekly-rest/${id}/reject`, data);
  return extractData(response);
}
